import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import Text from '@/shared-components/text/components/Text';

import './styles/Info.css';

export default function Info({ artwork, typeOfArtwork }) {
  return (
    <>
      <ArtworkImage
        image={artwork.artwork_media.artwork_main_picture.image_id}
        imageTemplateClassName="add-review__artwork-picture template"
        imageClassName="add-review__artwork-picture"
      />

      <Text 
        className="add-review__info-text add-review__info-title" 
      >
                    Congratulations on your latest addition to your collection!
      </Text>

      <Text 
        className="add-review__info-text add-review__info-description" 
      >
                    A work of art is a window into the soul of its creator, 
                    a mirror of the world, and an invitation to deepen our understanding.
      </Text>

      <Text 
        className="add-review__info-text add-review__info-evaluate" 
      >
        {
          typeOfArtwork === "original" ?
            `Evaluate your buying experience with ${artwork.artwork_about.artwork_gallery.user_name}`
            :
            "Evaluate your buying experience with Suarte"
        }
      </Text>
    </>
  );
}
